export default __webpack_public_path__ + "static/media/flag_unitedKingdom.81bde8a0.webp";